<script setup=""></script>

<template>
  <svg fill="currentColor" height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_240_2620)">
      <path
        d="M27.6721 9.33794V13.6929C27.6721 13.6929 23.9082 13.898 20.9285 11.4129V21.3895C20.9285 21.7755 20.8923 22.1495 20.82 22.5356C20.458 24.3089 18.9501 28.7966 13.0148 29.3153C12.7132 29.3394 12.4116 29.3394 12.11 29.3153C10.4211 29.1706 5.36644 28.2296 4.36515 22.1495C4.24452 21.4498 4.23245 20.7381 4.34103 20.0384C4.64262 17.9634 6.78994 12.2573 13.8472 12.945V17.2758C13.8472 17.2758 10.8192 16.552 9.34743 18.8923C8.57536 20.1228 8.49092 21.667 9.14235 22.9578C9.63696 23.947 10.6382 24.9603 12.5926 25.0327C13.4129 25.0327 16.0186 24.7432 16.5977 21.5222V2.66675H20.9285C20.9285 2.66675 20.9285 8.91571 27.6842 9.33794H27.6721Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_240_2620">
        <rect fill="white" height="32" width="32" />
      </clipPath>
    </defs>
  </svg>
</template>
